/**
 * CostCategoriesEditor Component
 *
 * Entity-specific editor for CostCategories lookup table
 */

import {
  useCostCategories,
  useCreateCostCategory,
  useUpdateCostCategory,
  useDeleteCostCategory,
} from '@medsuite/api-client';

import EntityEditor from '../components/EntityEditor';

interface CostCategoriesEditorProps {
  onDataLoaded?: (count: number) => void;
}
export default function CostCategoriesEditor({ onDataLoaded }: CostCategoriesEditorProps) {
  const { data: costCategories = [], isLoading, error } = useCostCategories();
  const addMutation = useCreateCostCategory();
  const updateMutation = useUpdateCostCategory();
  const deleteMutation = useDeleteCostCategory();

  const columns = [
    { key: 'cost_category_id', label: 'ID', readonly: true },
    { key: 'cost_category_name', label: 'Category Name', type: 'text' as const },
  ];

  return (
    <EntityEditor
      title="Cost Categories"
      columns={columns}
      data={costCategories as unknown as Record<string, unknown>[]}
      isLoading={isLoading}
      error={error}
      primaryKey="cost_category_id"
      onDataLoaded={onDataLoaded}
      onAdd={async (item) => {
        await addMutation.mutateAsync(item as { cost_category_name: string });
      }}
      onUpdate={async (id, item) => {
        await updateMutation.mutateAsync({ id: Number(id), data: item as { cost_category_name: string } });
      }}
      onDelete={(id) => deleteMutation.mutateAsync(Number(id))}
      isAdding={addMutation.isPending}
      isUpdating={updateMutation.isPending}
      isDeleting={deleteMutation.isPending}
    />
  );
}
